module.exports = __webpack_public_path__ + "static/media/18luohanshanadj.f026532f.webp";